import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export type ExcelHeadCell<DataType> = {
  key: Extract<keyof DataType, string>;
  label: string;
};
export type ExcelData<DataType> = {
  excelHeaders: ExcelHeadCell<DataType>[];
  excelData: Array<DataType>;
};

export function buildCsvPrintData<T>(
  { excelHeaders, excelData }: ExcelData<T>,
  language: string
): { CSVheaders: string[]; CSVData: unknown[][]; separatorByLang: string } {
  const columnsKeys = excelHeaders.map(item => item.key);
  const CSVheaders = excelHeaders.map(header => header.label);
  const CSVData = excelData.map(row => columnsKeys.map((column: keyof T) => row[column]));
  const separatorByLang = language === "de" ? ";" : ",";
  return { CSVheaders, CSVData, separatorByLang };
}

export function useExcelPrint<T>(excelData: ExcelData<T>) {
  const { i18n } = useTranslation();
  return useMemo(() => buildCsvPrintData(excelData, i18n.language), [excelData, i18n.language]);
}
